import React, {useContext, useEffect} from "react";
import {ProductCustomizerCollectionProvider} from "@contexts/ProductCustomizerCollection.jsx"
import {ProductCustomizerVariantContext} from "@contexts/ProductCustomizerVariant.jsx"
import {CartContext} from "@contexts/Cart.jsx"
import ProductCustomizerCollection from "./ProductCustomizerCollection.jsx";
import ProductCustomizerItem from "./ProductCustomizerItem.jsx";
import {getRestIdFromGid} from "@utility/shopify";

export default () => {

  const { loading, variant } = useContext(ProductCustomizerVariantContext);
  const { cart } = useContext(CartContext);

  const collectionHandle = variant?.compatibilityCollection?.value;
  const partnerProductData = variant?.partnerVariant?.value;
  const compatibilityKeyString = variant?.compatibilityKeys?.value;

  const systemItem = cart?.items?.find((item) => {
    return getRestIdFromGid(variant?.id) == item.id;
  })

  let compatibilityKeys;
  if(compatibilityKeyString){
    try{
      compatibilityKeys = JSON.parse(compatibilityKeyString);
    }catch(e){
      console.error(e);
      console.error(`Unable to parse compatibilityKeys from ${variant.id}`);
    }
  }

  const includedItems = {
    title: variant?.includedItemsTitle?.value,
    items: variant?.includedItems?.references
  };

  return <div>
          {loading || !variant ?
            "Loading"
          :
            <>
              <div className="cart-drawer__line-items customizer_main-item">
                <ProductCustomizerItem editable={false} item={systemItem} variant={variant} includedItems={includedItems} />
              </div>
              <ProductCustomizerCollectionProvider collectionHandle={collectionHandle} partnerProductData={partnerProductData} compatibilityKeys={compatibilityKeys}>
                <ProductCustomizerCollection />
              </ProductCustomizerCollectionProvider>
            </>
          }
      </div>
}
